import ContactMethodPage from "./ContactMethodPage";

export default ContactMethodPage;
